import React, { lazy, memo } from 'react';
const About = () => {
  return <div className="bg-white" data-id="element-305">
      <div className="relative bg-red-600 text-white" data-id="element-306">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1501446529957-6226bd447c46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80")'
      }} data-id="element-307"></div>
        <div className="container mx-auto px-4 py-24 relative z-10" data-id="element-308">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-309">
            About Forsa Co.
          </h1>
          <p className="text-xl text-center max-w-3xl mx-auto" data-id="element-310">
            For organizing tourist trips and external tourist guidance
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-311">
        <div className="max-w-4xl mx-auto" data-id="element-312">
          <div className="mb-16" data-id="element-313">
            <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-314">Our Story</h2>
            <p className="text-gray-700 mb-4" data-id="element-315">
              Forsa Co. was established with a vision to provide exceptional
              travel experiences that create lasting memories. Our journey began
              with a passion for exploration and a commitment to sharing the
              world's most remarkable destinations with travelers.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-316">
              Over the years, we have grown to become a trusted name in the
              travel industry, known for our attention to detail, personalized
              service, and expertly crafted itineraries that showcase the best
              each destination has to offer.
            </p>
          </div>
          <div className="mb-16" data-id="element-317">
            <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-318">
              Our Mission
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-319">
              At Forsa Co., our mission is to create unforgettable travel
              experiences that inspire, educate, and bring joy to our clients.
              We are committed to providing exceptional service from the moment
              you begin planning your trip until you return home.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-320">
              We believe that travel has the power to transform lives, broaden
              perspectives, and create connections across cultures. Our goal is
              to make these enriching experiences accessible, seamless, and
              enjoyable for every traveler.
            </p>
          </div>
          <div className="mb-16" data-id="element-321">
            <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-322">
              Why Choose Forsa Co.
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-323">
              <div data-id="element-324">
                <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-325">
                  Expertise
                </h3>
                <p className="text-gray-700" data-id="element-326">
                  Our team of travel specialists has extensive knowledge and
                  first-hand experience of the destinations we offer.
                </p>
              </div>
              <div data-id="element-327">
                <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-328">
                  Personalized Service
                </h3>
                <p className="text-gray-700" data-id="element-329">
                  We take the time to understand your preferences and create
                  customized itineraries that match your interests.
                </p>
              </div>
              <div data-id="element-330">
                <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-331">
                  Value
                </h3>
                <p className="text-gray-700" data-id="element-332">
                  We negotiate the best rates with our partners to offer you
                  competitive prices without compromising on quality.
                </p>
              </div>
              <div data-id="element-333">
                <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-334">
                  Support
                </h3>
                <p className="text-gray-700" data-id="element-335">
                  Our dedicated customer service team is available 24/7 to
                  assist you before, during, and after your journey.
                </p>
              </div>
            </div>
          </div>
          <div className="mb-16" data-id="element-336">
            <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-337">
              Visit Our Office
            </h2>
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-md" data-id="element-338">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.8954956116354!2d47.990117099999995!3d29.3759371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9c83ce455983%3A0xc3ebaef5af09b90e!2z2YHYsdiz2Kkg2YTZhNiz2YrYp9it2Kkg2YjYp9mE2KXYsdiz2KfZhNmK2KfYqiDYp9mE2LPZitin2K3ZitipINin2YTYrtin2LHYrNmK2Kk!5e0!3m2!1sen!2skw!4v1716156099736!5m2!1sen!2skw" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Forsa Tours Location" data-id="element-339"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default About;